export const CalendarView: React.FunctionComponent = () => {
  return <div>Deprecated. See components/calendar-widget</div>;
};
